import React from 'react';
import moment from 'moment';
import TagFacesIcon from '@material-ui/icons/TagFaces';
import SearchIcon from '@material-ui/icons/Search';
import CheckIcon from '@material-ui/icons/Check';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

import Grid from '../../../Common/Grid';
import getNoDataCellComponent from '../../../Common/NoDataCellComponent';
import styles from './styles';
import { name, formatLocation } from '../../../../utils/helper';
import Status from '../../../Common/Status';

const COLUMNS = [
  { name: 'itemType', title: 'Item Type' },
  { name: 'exceptionType', title: 'Exception Type' },
  { name: 'origin', title: 'Origin' },
  { name: 'destination', title: 'Intended Destination' },
  { name: 'exceptionLocation', title: 'Exception Location' },
  { name: 'stage', title: 'Stage' },
  { name: 'createdBy', title: 'Created By' },
  { name: 'createdAt', title: 'Created At' },
  { name: 'status', title: 'Status' },
  { name: 'action', title: ' ' },
];

const COLUMN_EXTENSIONS = [
  // { columnName: 'name', width: 200 },
  // { columnName: 'mobile', width: 100 },
  // { columnName: 'email', width: 150 },
  // { columnName: 'action', width: 100 },
];

const renderExceptionType = (type = { code: 'Unknown' }) => {
  switch (type.code) {
    case 'MissingItem':
      return <Status label="Missing" containerStyle={{ backgroundColor: 'red' }}/>;
    case 'UnexpectedItem':
      return <Status label="Unexpected" containerStyle={{ backgroundColor: 'red' }}/>;
    default:
      return <Status label="Unknown" containerStyle={{ backgroundColor: 'red' }}/>;
  }
};

const getCellComponent = (onViewException, onResolveException) => ({ row, column, value }) => {
  switch (column.name) {
    case 'itemType':
      return row.item.type.name;
    case 'exceptionType':
      return renderExceptionType(row.type);
    case 'origin':
      return formatLocation(row.task.origin);
    case 'destination':
      return formatLocation(row.task.destination);
    case 'exceptionLocation':
      return formatLocation(row.occurredAt);
    case 'stage':
      return value ? value.name : '';
    case 'createdAt':
      return moment(row.created.at).format('lll');
    case 'createdBy':
      return name(row.created.by);
    case 'status':
      return row.resolved ? (<Status label="Resolved" containerStyle={{ backgroundColor: 'green' }}/>) :
        (<Status label="Open" containerStyle={{ backgroundColor: 'red' }}/>);
    case 'action':
      return (<div>
        <Tooltip title="View Exception">
          <IconButton onClick={() => onViewException(row)}>
            <SearchIcon/>
          </IconButton>
        </Tooltip>
        <Tooltip title="Resolve">
          <IconButton onClick={() => onResolveException(row)}>
            <CheckIcon/>
          </IconButton>
        </Tooltip>
      </div>);
    default:
      return value;
  }

};

const ExceptionsGrid = ({ data, fetch, onViewException, onResolveException, showDialog }) => {
  return <Grid
    columns={COLUMNS}
    columnExtensions={COLUMN_EXTENSIONS}
    cellComponent={getCellComponent(onViewException, onResolveException)}
    fetch={fetch}
    data={data}
    noDataCellComponent={getNoDataCellComponent(<TagFacesIcon style={styles.noData}/>, 'exceptions')}
  />;
};

export default ExceptionsGrid;



// WEBPACK FOOTER //
// ./src/components/Reports/ExceptionsReport/ExceptionsGrid/index.js